module.exports = __webpack_public_path__ + "assets/img/Kaplan-Professional-Pillar-Page-Resource-w960.56cc2797.jpg";